import BoardList from "../components/BoardList";

const ListBoardPage = () => {
  return (
    <BoardList />
  );
};

export default ListBoardPage;
